import React, { useState, useEffect } from 'react'
import { Button, Icon, makeStyles, Typography, Checkbox, Avatar } from '@material-ui/core'
import clsx from 'clsx'
import AddressBlock from './AddressBlock'

const useStyles = makeStyles(() => ({
	clientWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 16,
		borderRadius: 6,
		background: '#F9F9F9'
	},
	userIcon: {
		width: '16px',
		height: '18px',
		'&:before': {
			color: '#777679'
		}
	},
    pets: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        paddingTop: 24,
        overflowY: 'scroll'
    },
    pet: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: 12,
        borderTop: '1px solid #D0CFD2',
        borderLeft: '1px solid #D0CFD2',
        borderRight: '1px solid #D0CFD2',
    }
}))

const PetBlock = ({ household, onClearHousehold, pet, selectedPets = [], togglePet }) => {
	const classes = useStyles()

	if (!household) {
		return null
	}

	const handleOnClearHousehold = () => {
		if (onClearHousehold) {
			onClearHousehold()
		}
	}

	return (
        <div>
            <div className={classes.clientWrapper}>
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Icon
                        className={clsx([classes.userIcon, 'far fa-user'])}
                        style={{
                            fontSize: '16px',
                            padding: '2px',
                            marginTop: '3px',
                            marginRight: '24px'
                        }}
                    />
                    <div>
                        <Typography variant="body2">{household?.full_name || 'No name'}</Typography>
                    </div>
                </div>
                <div>
                    <Button color="secondary" variant="outlined" onClick={handleOnClearHousehold}>
                        Change Client
                    </Button>
                </div>
            </div>
            <div className={classes.pets}>
                <Typography variant="body2" style={{ fontWeight: '800', marginBottom: 12 }}>Add Pet</Typography>
                <Typography variant="body2" style={{ marginBottom: 12 }}>Select which pet to add from the list of existing pet profiles on this client’s account. </Typography>
                {household?.pets?.length ? household.pets.map((p, i) => {

                    const isLastPet = i === household.pets.length - 1
                    const isFirstPet = i === 0

                    const borderStyle = isLastPet ? { borderBottom: '1px solid #D0CFD2' } : {}
                    if (isLastPet) {
                        borderStyle.borderBottomLeftRadius = 12
                        borderStyle.borderBottomRightRadius = 12
                    }
                    if (isFirstPet) {
                        borderStyle.borderTopLeftRadius = 12
                        borderStyle.borderTopRightRadius = 12
                    }

                    const checked = !!selectedPets.find(sp => sp._id === p._id)

                    return (
                        <div className={classes.pet} style={borderStyle}>
                            <Checkbox
                                checked={checked}
                                onChange={(e, v) => togglePet({ ...p, full_name: `${p.name} ${household.last_name}` })}
                                disabled={pet?.beefs?.includes(p._id)}
                            />
                            <Avatar src={p.image_url} style={{ marginRight: 12, marginLeft: 4 }}/>
                            <Typography variant="body2">{p.name} {household.last_name}</Typography>
                        </div>    
                    )
                }) : <Typography variant="body2">No pets found</Typography>}
            </div>
        </div>
	)
}

export default PetBlock
